import { graphql } from 'gatsby';

export type StrapiVideoFile = { fields: { assetUrl: string } } | null;

export type StrapiVideo = {
  videoDesktop: StrapiVideoFile;
  videoMobile: StrapiVideoFile;
};
export const VideoFragment = graphql`
  fragment VideoFragment on VIDEO_FILES {
    videoDesktop: VideoDesktop {
      fields {
        assetUrl
      }
    }
    videoMobile: VideoMobile {
      fields {
        assetUrl
      }
    }
  }
`;

export const gatsbyVideoDataFromStrapiVideo = (video: StrapiVideoFile) => {
  return video
    ? [
        {
          src: video.fields.assetUrl,
          type: 'video/mp4',
        },
      ]
    : [];
};
